/**
 * Generated by `./scripts/prebuild/generate-icons-experimental.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../../contexts/EncoreContext";
import { Experimental__Icon, findClosestGlyphAvailable } from "../../";
/**
 * @deprecated The name Experimental__IconFacebook is deprecated and will be archived soon. Use IconFacebook instead.
 */

export function Experimental__IconFacebook(props) {
  var iconList = [{
    size: 16,
    svgContent: "<path d='M8.929 14.992H6.032v-7H4.587V5.587h1.445V4.135q0-1.548.73-2.341Q7.492 1 9.167 1h1.936v2.413H9.897q-.334 0-.532.055-.198.056-.294.195-.095.139-.119.29-.023.15-.023.428v1.206h2.182l-.254 2.405H8.93v7z'/>"
  }, {
    size: 24,
    svgContent: "<path d='M13.393 22.488H9.047v-10.5H6.881V8.381h2.166v-2.18c0-1.547.365-2.718 1.095-3.512.731-.793 1.934-1.19 3.609-1.19h2.904v3.619h-1.809c-.333 0-.6.028-.798.084a.752.752 0 00-.44.29 1.062 1.062 0 00-.178.436c-.024.15-.037.364-.037.643v1.81h3.274l-.38 3.607h-2.893v10.5l-.001-.001z'/>"
  }, {
    size: 32,
    svgContent: "<path d='M17.857 29.984h-5.794v-14H9.175v-4.81h2.888V8.27q0-3.095 1.46-4.683Q14.985 2 18.334 2h3.873v4.825h-2.412q-.667 0-1.064.112-.397.11-.587.388-.19.278-.238.58-.048.301-.048.857v2.413h4.365l-.508 4.81h-3.857v14z'/>"
  }, {
    size: 64,
    svgContent: "<path d='M36 60H24V32h-6V22h6v-5.46q0-6.159 2.984-9.35Q29.968 4 36.667 4H44v10h-4.413q-1.333 0-2.127.175-.793.174-1.174.666-.381.492-.476 1.048-.096.555-.096 1.635V22h8.73L43.43 32H36v28z'/>"
  }];
  var iconListRedraw = [{
    size: 16,
    svgContent: "<path d='M16 8a8 8 0 10-9.25 7.903v-5.59H4.719V8H6.75V6.237c0-2.005 1.194-3.112 3.022-3.112.875 0 1.79.156 1.79.156V5.25h-1.008c-.994 0-1.304.617-1.304 1.25V8h2.219l-.355 2.313H9.25v5.59A8.002 8.002 0 0016 8z'/>"
  }, {
    size: 24,
    svgContent: "<path d='M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.093 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.563V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z'/>"
  }];
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);
  var iconListFallback = iconList.length === 0 ? iconListRedraw : iconList;
  var closestSize = findClosestGlyphAvailable(status === encoreContextStatus.deprecated ? iconListFallback : iconListRedraw, props.iconSize || 24);

  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };

  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };

  return /*#__PURE__*/React.createElement(Experimental__Icon, Object.assign({}, props, {
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}
export default Experimental__IconFacebook;